"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppointmentGenderPreference = exports.ClientStatus = void 0;
var ClientStatus;
(function (ClientStatus) {
    ClientStatus["DECLINED"] = "Declined";
    ClientStatus["NON-MEMBER"] = "Non-Member";
    ClientStatus["ACTIVE"] = "Active";
    ClientStatus["EXPIRED"] = "Expired";
    ClientStatus["SUSPENDED"] = "Suspended";
    ClientStatus["TERMINATED"] = "Terminated";
})(ClientStatus = exports.ClientStatus || (exports.ClientStatus = {}));
var AppointmentGenderPreference;
(function (AppointmentGenderPreference) {
    AppointmentGenderPreference["NONE"] = "None";
    AppointmentGenderPreference["FEMALE"] = "Female";
    AppointmentGenderPreference["MALE"] = "Male";
})(AppointmentGenderPreference = exports.AppointmentGenderPreference || (exports.AppointmentGenderPreference = {}));
//# sourceMappingURL=ClientTypes.js.map